<template>
  <div
    v-if="!!last"
  >

    <!-- Today graphs -->
    <v-container class="pa-0">
      <v-row>
        <!-- Velocitat del vent -->
        <v-col>
          <GraphBox
            title="Velocitat del vent"
            icon="mdi-weather-windy"
          >
            <template v-slot:graph>
              <Semicircle
                :value="data_windspeed"
                title="Velocitat del vent"
                unitats="km/h"
                :min="0"
                :max="400"
                class="pr-4 pl-4"
                style="min-width: 15em"
              />
            </template>
          </GraphBox>
        </v-col>

        <!-- Sensació tèrmica -->
        <v-col>
          <GraphBox
            title="Sensació tèrmica"
            icon="mdi-thermometer"
          >
            <template v-slot:graph>
              <Semicircle
                :value="data_thw"
                title="Sensació tèrmica"
                unitats="°C"
                :min="-45"
                :max="45"
                class="pr-4 pl-4"
                style="min-width: 15em"
              />
            </template>
          </GraphBox>
        </v-col>

        <!-- Humitat relativa -->
        <v-col>
          <GraphBox
            title="Humitat relativa"
            icon="mdi-water-percent"
          >
            <template v-slot:graph>
              <Semicircle
                :value="data_humidity"
                title="Humitat relativa"
                unitats="%"
                :min="0"
                :max="100"
                class="pr-4 pl-4"
                style="min-width: 15em"
              />
            </template>
          </GraphBox>
        </v-col>

      </v-row>
      <v-row>

        <!-- Barres de temperatura -->
        <v-col
          :class="mobile ? '' : 'col-8'"
          style="min-width: 360px"
        >
          <GraphBox
            title="Temperatures"
            icon="mdi-thermometer"
          >
            <template v-slot:graph>
              <TemperatureBars
                :entries="data_temperaturebars"
                class="pr-4 pl-4"
              />
            </template>
          </GraphBox>
        </v-col>

        <!-- Índex UV -->
        <v-col>
          <GraphBox
            title="Índex de radiació ultraviolada"
            icon="mdi-sun-wireless"
          >
            <template v-slot:graph>
              <Semicircle
                :value="data_uv"
                title="Índex UV"
                unitats=""
                :min="0"
                :max="12"
                class="pr-4 pl-4"
                style="min-width: 15em"
              />
            </template>
          </GraphBox>
        </v-col>


      </v-row>
      <v-row>
        <v-col>
          <v-divider></v-divider>

          <!-- Filtres -->
          <div>
            <v-container>
              <v-row>
                <v-col justify="end" align="center">
                  <v-container class="pa-2" style="max-width: 50em">
                    <v-row>
                      <v-col justify="end" align="center">
                        <v-menu
                          v-model="period_format_menu"
                          offset-y
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              color="primary"
                              class="dades_filter_btn"
                            >
                              {{ period_format_text }}
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              v-for="item in period_options"
                              :key="item.text"
                              @click="period_format = item.value; filter_format_menu = false"
                            >
                              <v-list-item-title>
                                {{ item.text }}
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>

                      </v-col>
                      <v-col justify="end" align="center">

                        <div>
                          <!-- Specific date picker -->
                          <v-menu
                            v-model="filter_date_menu"
                            :close-on-content-click="false"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                color="primary"
                                class="dades_filter_btn"
                              >
                                {{ display_filter_date }}
                              </v-btn>
                            </template>

                            <v-date-picker
                              v-model="filter_date"
                              :type="period_format == 'day' ? 'date' : 'month'"
                              no-title
                              scrollable
                              locale="ca-ES"
                              v-if="period_format != 'year'"
                              class="dades_filter_width"
                            ></v-date-picker>

                            <v-list v-else>
                              <v-list-item
                                v-for="item in filter_date_years"
                                :key="item.text"
                                @click="filter_date = item.value; filter_date_menu = false"
                                class="dades_filter_width"
                              >
                                <v-list-item-title>
                                  {{ item.text }}
                                </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>
      </v-row>
      <v-row>

        <!-- Pressió atmosfèrica -->
        <v-col
          :class="mobile ? 'col-12' : ''"
        >
          <GraphBox
            title="Pressió atmosfèrica"
            icon="mdi-gauge"
            v-if="hack"
          >
            <template v-slot:graph>
              <Barometer
                :entries="data_barometer"
                :start_date="start_date"
                :precision="unit_to_precision_unit"
              />
            </template>
          </GraphBox>
        </v-col>

        <!-- Pluges -->
        <v-col
          :class="mobile ? 'col-12' : ''"
        >
          <GraphBox
            title="Pluges"
            icon="mdi-weather-pouring"
          >
            <template v-slot:graph>
              <Rain
                :entries="data_rain"
                :start_date="start_date"
                :precision="unit_to_precision_unit"
              />
            </template>
          </GraphBox>
        </v-col>
      </v-row>

      <v-row>
        <!-- Temperatures històriques -->
        <v-col>
          <GraphBox
            title="Temperatures"
            icon="mdi-thermometer"
            v-if="hack"
          >
            <template v-slot:graph>
              <Temperature
                ref="chart_temperature"
                :entries="data_temperature"
                :start_date="start_date"
                :precision="unit_to_precision_unit"
              />
            </template>
          </GraphBox>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
 import GraphBox from '@/components/GraphBox';
 import Temperature from '@/components/charts/Temperature';
 import Barometer from '@/components/charts/Barometer';
 import Rain from '@/components/charts/Rain';
 import Semicircle from '@/components/charts/Semicircle';
 import TemperatureBars from '@/components/charts/TemperatureBars';
 import { mapState, mapActions } from 'vuex';
 import utils from '@/utils';
 import units from '@/units';

 export default {
   name: 'Analisi',

   components: {
     GraphBox,
     Temperature,
     TemperatureBars,
     Barometer,
     Rain,
     Semicircle,
   },

   data: () => ({
     unit: 'hour',
     filter_date_menu: false,
     filter_date: utils.shiftDate(new Date(), 'Month', 0).toISOString().split('T')[0],
     start: utils.defaultDateRange()[0],
     end: utils.defaultDateRange()[1],
     period_options: [
       /* {value: 'day',   text: 'Diàries'}, */
       {value: 'month', text: 'Mensuals'},
       {value: 'year',  text: 'Anuals'},
     ],
     period_format: 'month',
     period_format_menu: false,
     hack: true,
   }),

   mounted() {
     this.filter_date = utils.shiftDate(new Date(), 'Month', 0).toISOString().split('T')[0];
     this.update_graphs();
   },

   /* created() {
    *   this.filter_date = (new Date()).toISOString().split('T')[0];
    *   this.update_graphs();
    * },
    */

   computed: {
     ...mapState([
       'last',
       'analisi_data',
       'analisi_unit',
     ]),

     mobile() {
       return utils.isMobile();
     },

     filter_date_years() {
       // [{value: '2022-01-01', text: '2021'}]
       const res = [];
       let now   = 2021;
       let end   = new Date().getFullYear();
       while (now <= end)
         res.push(now++);
       return res.reverse().map(x => ({
         value: `${x}-01-01`,
         text: x,
       }));
     },

     period_format_text() {
       return (this.period_options.filter(
         x => x.value == this.period_format
       ) || [{text: 'Periòde'}])[0].text;
     },

     display_filter_date() {
       let dt = new Date(this.filter_date)
       if (this.period_format == 'month')
         return units.date2locale_date_yymm(dt);
       else if (this.period_format == 'year')
         return dt.getFullYear();
       return units.date2locale_date_yymmdd(dt);
     },

     unit_to_precision_unit() {
       return this.unit;
     },

     unit_to_seconds() {
       return ({'hour': 3600, 'day': 3600*24, 'month': 3600*24*30})[this.unit]
     },

     start_date() {
       return +((this.analisi_data[0] || {}).date || null);
     },

     data_humidity() {
       return this.last.hum || 0;
     },

     data_windspeed() {
       return +units.ms2kmh(this.last.wind_speed || 0);
     },

     data_thw() {
       return +units.round(this.last.heat_index || 0, 1);
     },

     data_uv() {
       return this.last.uv_index || 0;
     },

     data_temperaturebars() {
       function f(n) {
         return +units.round(n || 0, 1);
       }
       return [
         f(this.last.temp),
         f(this.last.temp_in),
         f(this.last.thw_index),
         f(this.last.heat_index_in),
         f(this.last.thsw_index),
         f(this.last.dew_point),
         f(this.last.wet_bulb),
       ];
     },

     data_temperature() {
       return {
         avg: this.analisi_data.map(e => [+units.round(e.temp_avg, 1)]),
         min: this.analisi_data.map(e => [+units.round(e.temp_min, 1)]),
         max: this.analisi_data.map(e => [+units.round(e.temp_max, 1)]),
       };
     },

     data_barometer() {
       return {
         avg: this.analisi_data.map(e => [+units.round(e.bar_absolute_avg, 1)]),
         min: this.analisi_data.map(e => [+units.round(e.bar_absolute_min, 1)]),
         max: this.analisi_data.map(e => [+units.round(e.bar_absolute_max, 1)]),
       };
     },

     data_rain() {
       return this.analisi_data.map(e => [+e.date, e.rain_sum]);
     },

     data_windbarb() {
       return {
         dir: this.analisi_data.map(e => [e.wind_speed_avg]),
         avg: this.analisi_data.map(e => [e.wind_dir_avg]),
       };
     },
   },

   methods: {
     ...mapActions([
       'LOAD_ANALISI',
     ]),

     change(start, end) {
       this.start = start;
       this.end   = end;

       let diffdays = (end - start) / (1000 * 3600 * 24);

       if (diffdays < 7)
         this.unit = 'hour';
       else if (diffdays < 7*31)
         this.unit = 'day';
       else
         this.unit = 'month';

       this.LOAD_ANALISI({unit: this.unit, start: this.start, end: this.end});
     },

     update_graphs() {
       let dt  = new Date(this.filter_date);
       let end = null;
       if (this.period_format == 'month')
         end = new Date(dt.getFullYear(), dt.getMonth() + 1, 0, 23, 59);
       else if (this.period_format == 'year')
         end = new Date(dt.getFullYear(), 12, 31, 23, 59);
       else // day
         end = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 23, 59);
       this.change(dt, end);
     },
   },

   watch: {
     filter_date() {
       this.update_graphs();
     },

     start_date() {
       this.hack = false;
       this.$nextTick(() => { this.hack = true });
     },
   }
 };
</script>

<style>
 
</style>
